(function () {
  'use strict';

  // Desktop / fine-pointer only — touch devices have no cursor to enhance.
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var cfg = window.CURSOR_FX || {};
  if (!cfg.mug || !cfg.logo) return;

  // The logo cursor target (checked first, wins over the mug list)
  var LOGO_SEL = '.custom-hero__image';

  // The mug cursor targets — mirrors assets/site-mug-cursor.css
  var MUG_SEL = [
    'a img', 'a picture', 'a picture img',
    '.card-wrapper a img', '.card__media img', '.card__media > .media', '.card-wrapper .card__media',
    '.media--hover-effect img', '.collection-hero__image', '.banner__media img', 'button.card__media img',
    '.collage img', '.collage-card', '.collage-card .media', '.collage__item img', '.collage-card__link',
    '.slideshow img', '.slideshow__slide img', '.slideshow-media img', '.banner img',
    '.slider img', '.slider__slide img', '.slider__slide .media',
    '[class*="carousel"] img', '[class*="slider"] img', '[class*="slideshow"] img', '[class*="ticker"] img',
    '.logo-list img', '.ds-logo-list img',
    'video', '.deferred-media', '.deferred-media__poster', '.deferred-media video', '.video-section video', 'model-viewer'
  ].join(', ');

  // Build the follower with BOTH icons stacked (no src swap => no flicker)
  var root = document.createElement('div');
  root.className = 'cursor-fx';
  root.setAttribute('aria-hidden', 'true');
  var center = document.createElement('div');
  center.className = 'cursor-fx__center';
  var mugImg = document.createElement('img');
  mugImg.className = 'cursor-fx__icon cursor-fx__icon--mug';
  mugImg.alt = ''; mugImg.src = cfg.mug;
  var logoImg = document.createElement('img');
  logoImg.className = 'cursor-fx__icon cursor-fx__icon--logo';
  logoImg.alt = ''; logoImg.src = cfg.logo;
  center.appendChild(mugImg);
  center.appendChild(logoImg);
  root.appendChild(center);

  function mount() { if (!root.parentNode) document.body.appendChild(root); }
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);

  // Permanently hide the static native custom cursors on these same targets, so the
  // animated follower is the ONLY cursor there — no static-to-animated switch to see.
  var hideStyle = document.createElement('style');
  hideStyle.textContent =
    MUG_SEL.split(/,\s*/).map(function (s) { return 'html.cursor-fx-ready ' + s; }).join(',') +
    ',html.cursor-fx-ready ' + LOGO_SEL + '{cursor:none !important;}';
  (document.head || document.documentElement).appendChild(hideStyle);
  document.documentElement.classList.add('cursor-fx-ready');

  var curType = null;

  function show(type) {
    if (type !== curType) {
      root.classList.remove('cursor-fx--mug', 'cursor-fx--logo');
      root.classList.add('cursor-fx--' + type);
      curType = type;
    }
    root.classList.add('is-visible');
  }

  function hide() {
    root.classList.remove('is-visible');
    curType = null;
  }

  /* The position is written every move (cheap), but the expensive selector
     matching is throttled to one frame and skipped when the target hasn't
     changed — otherwise closest() runs a long selector list on every pixel. */
  var lastTarget = null, matchQueued = false;

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') { hide(); return; }

    // Position synchronously so the icon is already in place the instant it shows
    root.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';

    var t = e.target;
    if (!t || !t.closest) { hide(); return; }
    if (t === lastTarget || matchQueued) return;   // same element: nothing to re-evaluate

    matchQueued = true;
    requestAnimationFrame(function () {
      matchQueued = false;
      lastTarget = t;
      if (t.closest('.cursor-fx-catch')) return;   // the video overlay handles itself
      if (t.tagName === 'IFRAME' || t.closest('iframe')) { hide(); return; }
      var logoEl = t.closest(LOGO_SEL);
      var el = logoEl || t.closest(MUG_SEL);
      if (!el) { hide(); return; }
      show(logoEl ? 'logo' : 'mug');
    });
  }, { passive: true });

  /* ── Video embeds ──────────────────────────────────────────────
     A cross-origin iframe (YouTube/Vimeo) reports nothing about the pointer,
     which would leave the follower frozen. So we lay a transparent capture
     layer over each player: the mug keeps following across the whole video,
     and a click toggles play/pause through the player's JS API. */
  function playerCommand(iframe, func) {
    try {
      if (/youtube/.test(iframe.src)) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
      } else if (/vimeo/.test(iframe.src)) {
        iframe.contentWindow.postMessage(JSON.stringify({ method: func === 'playVideo' ? 'play' : 'pause' }), '*');
      }
    } catch (err) {}
  }

  function attachVideoOverlay(iframe) {
    var host = iframe.parentNode;
    if (!host || host.querySelector(':scope > .cursor-fx-catch')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var pad = document.createElement('div');
    pad.className = 'cursor-fx-catch';
    pad.setAttribute('aria-hidden', 'true');
    var playing = true;   // deferred media autoplays once loaded

    pad.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') { hide(); return; }
      root.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
      show('mug');
    });
    pad.addEventListener('pointerleave', hide);
    pad.addEventListener('click', function () {
      playing = !playing;
      playerCommand(iframe, playing ? 'playVideo' : 'pauseVideo');
    });

    host.appendChild(pad);
  }

  function scanForPlayers() {
    document.querySelectorAll('iframe.js-youtube, iframe.js-vimeo, deferred-media iframe, .video-section iframe')
      .forEach(attachVideoOverlay);
  }

  scanForPlayers();
  if ('MutationObserver' in window) {
    new MutationObserver(scanForPlayers).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Any other embed we don't manage: hide rather than freeze. */
  document.addEventListener('mouseover', function (e) {
    if (e.target && e.target.tagName === 'IFRAME' && !e.target.parentNode.querySelector(':scope > .cursor-fx-catch')) hide();
  }, true);

  document.addEventListener('mouseleave', hide);
  window.addEventListener('blur', hide);
  document.addEventListener('visibilitychange', function () { if (document.hidden) hide(); });
})();
